import {subscribeAuthIoMessage} from "../composables/useSocketIo";
import {useDownloadsStore} from "src/stores/downloads.store";
import {useNotify} from "nvd-u/composables/Notifiy";
import {useAuthStore} from "@/stores/auth.store";

export const onDownloadEvents = function () {
    const notify = useNotify()
    const auth = useAuthStore()
    const userId = auth.user?.id

    return subscribeAuthIoMessage(async event => {
        if (!auth.isLoggedIn || auth.user?.id !== userId) return
        let parsed: { message?: { data?: { type?: string; download?: Record<string, unknown> } } }
        try {
            parsed = JSON.parse(event.data)
        } catch {
            return
        }
        if (!parsed?.message?.data?.type) return
        const data = parsed.message.data
        if (!data) return

        switch (data.type) {
            case 'export_completed': {
                const downloads = useDownloadsStore()
                const download = downloads.downloads.find(d => d.id === data.download?.id)
                if (download && data.download) {
                    for (const key of Object.keys(data.download)) {
                        download[key] = data.download[key]
                    }
                } else if (data.download) {
                    downloads.downloads.unshift(data.download)
                }
                const completed = data.download
                if (completed?.file_url) {
                    const index = downloads.pendingReviewIds.indexOf(completed.id)
                    if (index !== -1) {
                        downloads.pendingReviewIds.splice(index, 1)
                        await downloads.downloadExportedSql(completed)
                    }
                    if (!auth.isLoggedIn || auth.user?.id !== userId) return
                    notify.success("Export completed", "Your SQL is ready to review in My Exports.")
                }
            }
        }
    })
}
